<section class="intro-wrapper">
    <div class="inner">
        <div class="intro-punks" #introPunks>
            <ng-container *ngFor="let p of visibleRandomPunks">
                <img
                        [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (p | tokenIdParse) + '.svg'"
                        [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
                        width="50"
                        height="50"
                />
            </ng-container>
        </div>
        <p *ngIf="environment.collection === 'cryptophunks'" class="intro">
            Welcome to <span class="pink">CryptoPhunks.com</span>, a new state-of-the-art NFT marketplace dedicated
            to the iconic 10,000 <span class="pink">CryptoPhunks</span> collection. Phunks face left and are
            censorship-resistant. Our mission is to be the ultimate hub for Phunk collectors and traders by
            continually introducing new features and refining the platform with valuable community feedback.
            <br/><br/>
            Discover the fascinating history of CryptoPhunks—read all about
            it <a href="https://phunks.gitbook.io/knowledge-base" target="_blank">here</a>!
            Stay connected by joining the official <a href="https://discord.gg/TPeyu3BY3m" target="_blank">Discord</a> and
            following them on <a href="https://x.com/CryptoPhunksV2" target="_blank">X</a>. Most importantly, enjoy the journey and have fun!
        </p>
        <p *ngIf="environment.collection === 'cryptopunks-v1'" class="intro">

            Welcome to <span class="pink">v1cryptopunks.com</span> — the community marketplace for the original 10,000
            <span class="pink">CryptoPunks V1</span>! Minted in 2017 from the first Larva Labs contract, V1s predate
            the V2s and are pioneers of the NFT space. A bug in the original smart contract led to the creation of
            V2s, but a 2021 wrapper brought V1s back to life for modern trading. Today, they’re valued for their
            authenticity, rarity, and historic significance. This platform was built for the V1 community — a space
            to buy, sell, and celebrate these iconic digital artifacts.
            <br/><br/>
            Join the vibrant <a href="https://discord.gg/hTKYrpTw" target="_blank">Discord</a> community
            and follow on <a href="https://x.com/v1punks" target="_blank">X</a> to stay connected with fellow collectors!
            Whether you're here to collect, trade, or learn, you’re part of the origin story.
        </p>
        <p *ngIf="environment.collection === 'cryptopunks'" class="intro">
            Welcome to <span class="pink">CryptoPunks.eth</span>, a new and innovative NFT marketplace
            dedicated exclusively to the iconic <span class="pink">10,000 {{ environment.collectionTitle }}
            collection</span>. A cutting-edge platform that offers a seamless and secure environment for trading
            <span class="pink">the original collectible digital asset {{ environment.collectionTitle }}</span>. Our
            mission is to be the ultimate destination for Punk collectors, traders, and enthusiasts by providing new
            features and regular maintenance at the direction of the {{ environment.collectionTitle }} community. You are
            encouraged to join our <a href="https://discord.com/invite/A9cv4wwVQd" target="_blank">Discord</a> and follow
            us on <a href="https://x.com/cryptopunks_ce" target="_blank">X</a>, but most importantly have fun!
        </p>
    </div>
</section>

<ng-container *ngIf="(dataSvc.marketData$ | async) as marketData">

    <section class="overview">
        <div class="inner">
            <app-overview></app-overview>
        </div>
    </section>

    <!-- Box -->
    <!-- <section class="punk-box">
      <div class="inner">

        <h3 i18n>{{ environment.tokenName }} Box</h3>
        <p i18n>Search a wallet address to view their {{ environment.tokenName }} collection or</p>
        <p>Enter a {{ environment.tokenName }} ID to view a specific {{ environment.tokenName }}</p>

        <form [formGroup]="punkBox" (ngSubmit)="onSubmit($event)">
          <div class="input-wrapper">
            <input
              type="text"
              placeholder="0x, ens or {{ environment.tokenName }}"
              formControlName="addressInput"
              [class.disabled]="punkBoxLoading"
            />

            <img
              src="/assets/loader-{{ themeSvc.theme$ | async }}.gif"
              width="20" height="20"
              *ngIf="punkBoxLoading"
            />
          </div>
          <ng-container *ngIf="punkBoxError">
            <p class="pink">Invalid Address or {{ environment.tokenName }}Id</p>
          </ng-container>
          <button i18n type="submit">Go</button>
        </form>

      </div>
    </section> -->

    <ng-container *ngIf="(dataSvc.ownedData$ | async) as ownedData">
        <ng-container *ngIf="ownedData.length">
            <section *ngIf="(stateSvc.walletAddress$ | async) as address">
                <div class="inner">
                    <h3 i18n>Owned</h3>

                    <div class="section-stats-wrapper">
                        <p i18n>Showing owned {{ environment.tokenName }},
                            <a
                                    class="pink"
                                    [routerLink]="['/', 'owned']"
                                    [href]="'/owned'"
                                    [queryParams]="{ address }">

                                ({{ ownedData.length | number }}) view all.
                            </a>
                        </p>
                    </div>

                    <app-punk-grid-view
                            [punkData]="ownedData || []"
                            [viewType]="'compact'"
                            [limit]="(stateSvc.isMobile$ | async) ? 100 : 110"
                            [marketType]="'owned'"
                            [sort]="'price-low'">
                    </app-punk-grid-view>
                </div>
            </section>
        </ng-container>
    </ng-container>

    <section>
        <div class="inner">
            <h3 i18n>For Sale</h3>

            <div
                    class="section-stats-wrapper"
                    *ngIf="(marketData | filter : 'listings') as listings">
                <p
                        i18n
                        *ngIf="(listings | calc : 'lowestListingPrice') as ethPrice">

                    The lowest price {{ environment.tokenName }} currently for sale is
                    <span class="bold">Ξ{{ ethPrice | number : numberOfDigits }} ({{ (ethPrice * ((dataSvc.usd$ | async) || 0)) | currency }} USD)</span>.
                </p>

                <p i18n>Showing lowest price offers,
                    <a
                            class="pink"
                            [routerLink]="['/listings']"
                            [href]="'/listings'">

                        ({{ marketData | count : 'listings' | number }}) view all.
                    </a>
                </p>
            </div>

            <app-punk-grid-view
                    [punkData]="marketData"
                    [viewType]="'compact'"
                    [limit]="(stateSvc.isMobile$ | async) ? 100 : 110"
                    [marketType]="'listings'"
                    [sort]="'price-low'">
            </app-punk-grid-view>
        </div>
    </section>

    <section>
        <div class="inner">
            <h3 i18n>Bids</h3>

            <div
                    class="section-stats-wrapper"
                    *ngIf="(marketData | filter : 'bids') as bids">

                <!-- <p
                  i18n
                  *ngIf="(bids | calc : 'averageYearBidPrice') as ethPrice">

                  The average bid over the last year was
                  <span class="bold">
                    Ξ{{ ethPrice | number : '1.2-2' }}
                    ({{ (ethPrice * ((dataSvc.usd$ | async) || 0)) | currency }} USD)
                  </span>.
                </p> -->

                <p
                        i18n
                        *ngIf="(bids | calc : 'averageBidPrice') as ethPrice">

                    The average currently open bid is
                    <span class="bold">
            Ξ{{ ethPrice | number : numberOfDigits }}
                        ({{ (ethPrice * ((dataSvc.usd$ | async) || 0)) | currency }} USD)
          </span>.
                </p>

                <p
                        i18n
                        *ngIf="(bids | calc : 'totalBidsValue') as ethPrice">

                    Total value of all current bids is
                    <span class="bold">
            Ξ{{ ethPrice | number : numberOfDigits }}
                        ({{ (ethPrice * ((dataSvc.usd$ | async) || 0)) | currency }} USD)
          </span>.
                </p>

                <p i18n>Showing top bids,
                    <a
                            class="pink"
                            [routerLink]="['/bids']"
                            [href]="'/bids'">

                        ({{ marketData | count : 'bids' | number }}) view all.
                    </a>
                </p>
            </div>

            <app-punk-grid-view
                    [punkData]="marketData"
                    [viewType]="'compact'"
                    [limit]="(stateSvc.isMobile$ | async) ? 100 : 110"
                    [marketType]="'bids'"
                    [sort]="'price-high'">
            </app-punk-grid-view>
        </div>
    </section>

    <section>
        <div class="inner">
            <h3 i18n>Sales</h3>

            <div
                    class="section-stats-wrapper"
                    *ngIf="(dataSvc.salesData$ | async) as sales">

                <p i18n>Showing most recent sales,
                    <a
                            class="pink"
                            [routerLink]="['/sales']"
                            [href]="'/sales'">

                        <!-- ({{ sales | count : 'sales' | number }})  -->
                        view all.
                    </a>
                </p>
            </div>

            <app-punk-grid-view
                    [punkData]="(dataSvc.salesData$ | async)"
                    [viewType]="'compact'"
                    [limit]="(stateSvc.isMobile$ | async) ? 100 : 110"
                    [marketType]="'sales'"
                    [sort]="'recent'">
            </app-punk-grid-view>
        </div>
    </section>

    <section *ngIf="(allData$ | async) as allData">
        <div class="inner">
            <h3 i18n>All</h3>

            <div class="section-stats-wrapper">

                <p i18n>
                    <a
                            class="pink"
                            [routerLink]="['/all']"
                            [href]="'/all'">

                        View all 10,000 {{ environment.tokenName }}s.
                    </a>
                </p>
            </div>

            <app-punk-grid-view
                    [punkData]="allData"
                    [viewType]="'compact'"
                    [limit]="(stateSvc.isMobile$ | async) ? 100 : 110"
                    [marketType]="'all'"
                    [sort]="'id'">
            </app-punk-grid-view>
        </div>
    </section>

</ng-container>